/* vibeo pop-up */
(() => {
  'use strict';
  if (window.__VIDPOP_INIT__) return; window.__VIDPOP_INIT__ = true;

  const OVERLAY_ID = 'ytm-overlay';
  const OPEN_ATTR  = 'aria-hidden';
  const BODY_CLASS_SCOPE = null; // set to 'template-index' to restrict to homepage
  const EXPLICIT_TRIGGER = ['[data-ytm-trigger]','[data-video]','[data-embed-url]','.ytm-trigger'].join(',');
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);

  // ---------- CSS ----------
  function injectStyles(){
    if (document.querySelector('style[data-ytm-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-ytm-style','1');
    style.textContent = `
      .ytm-overlay{position:fixed;inset:0;display:none;place-items:center;background:rgba(0,0,0,.6);z-index:2147483647}
      .ytm-overlay[${OPEN_ATTR}="false"]{display:grid}
      .ytm-dialog{
        position:relative;
        --ar-w:16; --ar-h:9;
        width:min(92vw,1000px,calc(92vh*var(--ar-w)/var(--ar-h)));
        height:min(92vh,calc(92vw*var(--ar-h)/var(--ar-w)),calc(1000px*var(--ar-h)/var(--ar-w)));
        background:#000;border-radius:12px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.35)
      }
      .ytm-frame{position:absolute;inset:0;width:100%;height:100%;border:0}
      .ytm-close{position:absolute;top:8px;right:8px;display:inline-grid;place-items:center;width:40px;height:40px;border-radius:999px;background:rgba(0,0,0,.55);color:#fff;border:0;cursor:pointer;pointer-events:auto;z-index:2}
      .ytm-close:focus{outline:2px solid #fff;outline-offset:2px}
      .ytm-sr{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}
    `;
    document.head.appendChild(style);
  }

  // ---------- Overlay + robust close ----------
  function ensureOverlay(){
    let overlay = document.getElementById(OVERLAY_ID);
    if (overlay) return overlay;

    injectStyles();
    overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'ytm-overlay';
    overlay.setAttribute(OPEN_ATTR,'true');
    overlay.innerHTML = `
      <div class="ytm-dialog" role="dialog" aria-modal="true" aria-label="Video dialog">
        <button type="button" class="ytm-close" data-ytm-close aria-label="Close video">
          <span aria-hidden="true">✕</span><span class="ytm-sr">Close</span>
        </button>
        <iframe class="ytm-frame" allow="autoplay; fullscreen; picture-in-picture"
                referrerpolicy="origin-when-cross-origin" allowfullscreen loading="eager"></iframe>
      </div>`;
    document.body.appendChild(overlay);

    function ytmClose(){
      try{
        overlay.setAttribute(OPEN_ATTR,'true');
        const frame = $('.ytm-frame', overlay);
        if (frame) frame.src = 'about:blank';
        const root = document.documentElement;
        if (overlay.dataset.scrollRestore !== undefined){
          root.style.overflow = overlay.dataset.scrollRestore;
          delete overlay.dataset.scrollRestore;
        } else root.style.overflow = '';
      }catch{}
    }

    // backdrop
    overlay.addEventListener('pointerup', e => {
      if (e.target === overlay && overlay.getAttribute(OPEN_ATTR)==='false'){
        e.preventDefault(); e.stopPropagation(); ytmClose();
      }
    }, {capture:true});
    // stop dialog bubbling
    $('.ytm-dialog', overlay).addEventListener('click', e => e.stopPropagation(), {capture:true});
    // ✕ close
    $('[data-ytm-close]', overlay).addEventListener('pointerup', e => {
      e.preventDefault(); e.stopPropagation(); ytmClose();
    }, {capture:true});
    // Esc close
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.getAttribute(OPEN_ATTR)==='false'){
        e.preventDefault(); ytmClose();
      }
    });

    overlay.ytmClose = ytmClose;
    window.__ytmClose = ytmClose;
    return overlay;
  }

  // ---------- Scroll lock ----------
  function lockScroll(){
    const root = document.documentElement;
    const overlay = ensureOverlay();
    overlay.dataset.scrollRestore = root.style.overflow || '';
    root.style.overflow = 'hidden';
  }

  // ---------- Aspect helpers ----------
  function setDialogAspect(dialog, aspect){
    let w=16, h=9;
    if (typeof aspect === 'string' && /^\s*\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?\s*$/.test(aspect)){
      const [a,b] = aspect.split('/'); w=parseFloat(a); h=parseFloat(b);
    } else if (typeof aspect === 'number' && isFinite(aspect) && aspect>0){
      w=aspect; h=1;
    }
    dialog.style.setProperty('--ar-w', String(w));
    dialog.style.setProperty('--ar-h', String(h));
  }
  function inferAspectFromURL(url){
    try{
      const u = new URL(url, location.href);
      const host = u.hostname.replace(/^www\./i,'');
      if (host.includes('youtube.com') || host==='youtu.be'){
        if (u.pathname.startsWith('/shorts/')) return '9/16';
      }
      return '16/9';
    }catch{ return '16/9'; }
  }

  // oEmbed (enabled): refine ratio accurately when possible
  async function refineAspectWithOEmbed(originalURL, dialog){
    try{
      const u = new URL(originalURL, location.href);
      const host = u.hostname.replace(/^www\./i,'');
      let oembed = '';
      if (host.includes('youtube.com') || host==='youtu.be'){
        // works well for many videos; may still return 16:9 for some YT items
        oembed = 'https://www.youtube.com/oembed?url=' + encodeURIComponent(originalURL) + '&format=json';
      } else if (host.includes('vimeo.com')){
        oembed = 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(originalURL);
      }
      if (!oembed) return;
      const res = await fetch(oembed, {mode:'cors'});
      if (!res.ok) return;
      const j = await res.json();
      if (j.width && j.height){
        const w = Number(j.width), h = Number(j.height);
        if (w>0 && h>0) setDialogAspect(dialog, `${w}/${h}`);
      }
    }catch{
      /* silently keep heuristic */
    }
  }

  // ---------- URL parsing ----------
  function parseYouTube(u){
    const host = u.hostname.replace(/^www\./i,'');
    if (!(host.includes('youtube.com') || host==='youtu.be')) return {ok:false};
    let id='';
    if (host==='youtu.be') id = u.pathname.split('/').filter(Boolean)[0] || '';
    else{
      const p = u.pathname;
      if (u.searchParams.get('v')) id = u.searchParams.get('v');
      else if (p.startsWith('/embed/')) id = p.split('/').pop() || '';
      else if (p.startsWith('/shorts/')) id = p.split('/').pop() || '';
    }
    if (!id) return {ok:false};
    const t = u.searchParams.get('t') || u.searchParams.get('start');
    const qs = t ? `?autoplay=1&start=${encodeURIComponent(t)}` : `?autoplay=1`;
    return {ok:true, url:`https://www.youtube.com/embed/${id}${qs}`, provider:'youtube'};
  }
  function parseVimeo(u){
    const host = u.hostname.replace(/^www\./i,'');
    if (!host.includes('vimeo.com')) return {ok:false};
    const segs = u.pathname.split('/').filter(Boolean);
    let id='';
    for (let i=segs.length-1;i>=0;i--){ if (/^\d+$/.test(segs[i])){ id=segs[i]; break; } }
    if (!id) return {ok:false};
    const qs = u.search ? (u.search.includes('autoplay=') ? u.search : (u.search + '&autoplay=1')) : '?autoplay=1';
    return {ok:true, url:`https://player.vimeo.com/video/${id}${qs}`, provider:'vimeo'};
  }
  function toEmbedURL(url){
    try{
      const u = new URL(url, location.href);
      const yt = parseYouTube(u); if (yt.ok) return {ok:true, url:yt.url, provider:yt.provider, original:url};
      const vm = parseVimeo(u);  if (vm.ok) return {ok:true, url:vm.url, provider:vm.provider, original:url};
      return {ok:false, url, original:url};
    }catch{ return {ok:false, url, original:url}; }
  }

  // ---------- Open / Close ----------
  function openPopup(embedURL, aspect, originalURL){
    const overlay = ensureOverlay();
    const frame = $('.ytm-frame', overlay);
    const dialog = $('.ytm-dialog', overlay);

    // explicit > heuristic; then refine via oEmbed (async)
    setDialogAspect(dialog, aspect || inferAspectFromURL(originalURL || embedURL));
    refineAspectWithOEmbed(originalURL || embedURL, dialog); // enabled

    frame.src = embedURL;
    overlay.setAttribute(OPEN_ATTR,'false');
    lockScroll();
    $('.ytm-close', overlay)?.focus();
  }
  function closePopup(){
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay?.ytmClose) overlay.ytmClose();
  }

  // ---------- Click handling ----------
  function wantNewTabClick(evt){
    if (evt.defaultPrevented) return true;
    if (evt.button && evt.button !== 0) return true;
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return true;
    return false;
  }
  function handleEvent(e){
    if (wantNewTabClick(e)) return;

    const link = e.target.closest?.('a[href]');
    if (link && !link.hasAttribute('data-ytm-ignore')){
      const href = link.getAttribute('href') || '';
      if (href && !href.startsWith('#') && !href.startsWith('mailto:') && !href.startsWith('tel:')){
        const emb = toEmbedURL(href);
        if (emb.ok){ e.preventDefault(); openPopup(emb.url, link.getAttribute('data-aspect') || '', link.href); return; }
      }
    }
    const trigger = e.target.closest?.(EXPLICIT_TRIGGER);
    if (trigger){
      let url = trigger.getAttribute('data-ytm-trigger') || trigger.getAttribute('data-video') || trigger.getAttribute('data-embed-url') || '';
      if (!url && trigger.tagName === 'A') url = trigger.getAttribute('href') || '';
      if (url){
        const emb = toEmbedURL(url);
        if (emb.ok){ e.preventDefault(); openPopup(emb.url, trigger.getAttribute('data-aspect') || '', url); return; }
      }
    }
  }

  if (BODY_CLASS_SCOPE && !document.body.classList.contains(BODY_CLASS_SCOPE)) return;
  document.addEventListener('pointerup', handleEvent, {capture:true});
  document.addEventListener('click',     handleEvent, {capture:true});
  window.addEventListener('pagehide', () => {
    document.removeEventListener('pointerup', handleEvent, {capture:true});
    document.removeEventListener('click',     handleEvent, {capture:true});
    closePopup();
  }, {once:true});
})();


/*!
 * nav-filter-allowlist.js
 * Hide <li class="navPages-item"> entries whose top-level label (.text inside first child link/action) is NOT in the allowlist.
 * - No :scope usage (avoids selector SyntaxError on older browsers)
 * - Idempotent, observes dynamic menu changes
 * - Accessibility-friendly: uses hidden + aria-hidden instead of remove()
 */
(() => {
  'use strict';

  if (window.__NAV_FILTER_ALLOWLIST__) return;
  window.__NAV_FILTER_ALLOWLIST__ = true;

  // Update this list as needed (case-insensitive match)
  const ALLOW = new Set([
    'AFL',
    'All Blacks',
    'BBL',
    'NRL',
    'WBBL',
    'Little Safari'
  ].map(s => s.toLowerCase()));

  const ITEM_SELECTOR = 'li.navPages-item';
  const TEXT_SELECTOR = '.text';
  const NAV_ROOTS = ['.navPages', '.sidebar', 'nav', '#navPages'].join(',');

  function getTopLabel(li) {
    if (!li) return '';
    // Prefer direct child anchor or .navPages-action; then find its .text
    let directChild = null;
    for (let i = 0; i < li.children.length; i++) {
      const c = li.children[i];
      if (c.matches && (c.matches('a') || c.matches('.navPages-action'))) {
        directChild = c; break;
      }
    }
    let node = null;
    if (directChild) node = directChild.querySelector(TEXT_SELECTOR);
    if (!node) node = li.querySelector('.navPages-action > .text');
    if (!node) node = li.querySelector(TEXT_SELECTOR);
    return node ? (node.textContent || '').trim() : '';
  }

  function setHidden(li, hidden) {
    if (!li) return;
    if (hidden) {
      if (!li.hasAttribute('data-prev-style-display')) {
        li.setAttribute('data-prev-style-display', li.style.display || '');
      }
      li.style.display = 'none';
      li.setAttribute('aria-hidden', 'true');
    } else {
      if (li.hasAttribute('data-prev-style-display')) {
        li.style.display = li.getAttribute('data-prev-style-display');
        li.removeAttribute('data-prev-style-display');
      } else {
        li.style.display = '';
      }
      li.removeAttribute('aria-hidden');
    }
  }

  function normalizeLabel(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function applyFilter(root) {
    const items = root ? root.querySelectorAll(ITEM_SELECTOR) : document.querySelectorAll(ITEM_SELECTOR);
    Array.prototype.forEach.call(items, (li) => {
      const label = normalizeLabel(getTopLabel(li));
      const keep = ALLOW.has(label);
      setHidden(li, !keep);
    });
  }

  // Initial application
  applyFilter();

  // Observe future mutations within likely nav roots
  const roots = Array.prototype.slice.call(document.querySelectorAll(NAV_ROOTS));
  const mo = new MutationObserver((muts) => {
    // Throttle by RAF
    if (mo._raf) return;
    mo._raf = requestAnimationFrame(() => {
      mo._raf = null;
      roots.forEach(applyFilter);
    });
  });
  roots.forEach(r => mo.observe(r, { subtree: true, childList: true }));

  window.addEventListener('pagehide', () => {
    mo.disconnect();
    if (mo._raf) cancelAnimationFrame(mo._raf);
  }, { once: true });

})();


/*!
 * hide-empty-text.js
 * Generic, opt-in helper: hide elements that are empty/whitespace-only.
 * - Add class "js-hide-if-empty" or attribute data-hide-if-empty to opt in
 * - Preserves previous inline display style and restores if content appears later
 * - Observes dynamic content changes (e.g., metafields, AJAX renders)
 */
(() => {
  'use strict';

  if (window.__HIDE_EMPTY_TEXT__) return;
  window.__HIDE_EMPTY_TEXT__ = true;

  const OPTIN = '.js-hide-if-empty,[data-hide-if-empty]';

  function isEffectivelyEmpty(el) {
    const txt = (el.textContent || '').replace(/\u00A0/g, ' ').trim();
    if (txt) return false;
    // consider non-empty if there is a direct child IMG/SVG/PICTURE
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i];
      var tag = c.tagName && c.tagName.toUpperCase();
      if (tag === 'IMG' || tag === 'SVG' || tag === 'PICTURE') {
        return false;
      }
    }
    return true;
  }

  function setHidden(el, hidden) {
    if (hidden) {
      if (!el.hasAttribute('data-prev-style-display')) {
        el.setAttribute('data-prev-style-display', el.style.display || '');
      }
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    } else {
      if (el.hasAttribute('data-prev-style-display')) {
        el.style.display = el.getAttribute('data-prev-style-display');
        el.removeAttribute('data-prev-style-display');
      } else {
        el.style.display = '';
      }
      el.removeAttribute('aria-hidden');
    }
  }

  function process(ctx) {
    const list = (ctx || document).querySelectorAll(OPTIN);
    Array.prototype.forEach.call(list, (el) => {
      setHidden(el, isEffectivelyEmpty(el));
    });
  }

  // Initial run
  process();

  // Observe for later content injection
  const mo = new MutationObserver((muts) => {
    // Coalesce via RAF
    if (mo._raf) return;
    mo._raf = requestAnimationFrame(() => {
      mo._raf = null;
      process();
    });
  });
  mo.observe(document.body, { subtree: true, childList: true, characterData: true });

  window.addEventListener('pagehide', () => {
    mo.disconnect();
    if (mo._raf) cancelAnimationFrame(mo._raf);
  }, { once: true });

})();


/*!
 * jdgm-mobile-based-on.js
 * Judge.me: On mobile (<768px), replace review summary text with "Based on N reviews"
 * - Reads N from data-number-of-reviews or parses fallback text
 * - Title-cases output string
 * - Throttled MutationObserver scoped to relevant containers
 * - Idempotent, resilient, no heavy global observers
 */
(() => {
  'use strict';

  if (window.__JDGM_MOBILE_BASED_ON__) return;
  window.__JDGM_MOBILE_BASED_ON__ = true;

  const MOBILE_MAX = 767; // viewport width threshold
  const WRAP_SELECTOR = '.jdgm-all-reviews-text';
  const TARGET_SELECTOR = '.jdgm-all-reviews-text__text';
  const TITLE_CLASS = 'jdgm-based-on-titlecase';

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function toBasedOnString(n) {
    const count = String(n);
    const word = count === '1' ? 'review' : 'reviews';
    // Already in desired case
    return `Based on ${count} ${word}`;
  }

  function parseCountFrom(el) {
    if (!el) return null;
    // Preferred: data-number-of-reviews
    const d = el.getAttribute('data-number-of-reviews');
    if (d && /\d/.test(d)) return d.replace(/[^\d]/g, '');

    // Fallback: parse existing text like "5.0 out of 5 stars based on 58 reviews"
    const m = (el.textContent || '').match(/based on\s+([\d,._\s]+)\s+reviews/i);
    if (m) return m[1].replace(/[^\d]/g, '');

    // Last resort: data attributes Judge.me sometimes includes
    const alt = el.getAttribute('data-shop-count');
    if (alt && /\d/.test(alt)) return alt.replace(/[^\d]/g, '');

    return null;
  }

  function ensureTitleClass(el) {
    if (!el) return;
    if (!el.classList.contains(TITLE_CLASS)) el.classList.add(TITLE_CLASS);
    // minimal CSS once
    if (!document.querySelector('style[data-jdgm-based-on]')) {
      const s = document.createElement('style');
      s.setAttribute('data-jdgm-based-on', '1');
      s.textContent = `
        .${TITLE_CLASS} { text-transform: capitalize; }
      `;
      document.head.appendChild(s);
    }
  }

  function process() {
    const targets = $$(TARGET_SELECTOR);
    const mobile = isMobile();

    targets.forEach((el) => {
      const original = el.getAttribute('data-orig') || '';
      if (!original) {
        // Store original on first run
        el.setAttribute('data-orig', el.textContent || '');
      }

      if (!mobile) {
        // Restore original on desktop
        const orig = el.getAttribute('data-orig');
        if (typeof orig === 'string') el.textContent = orig;
        el.classList.remove(TITLE_CLASS);
        return;
      }

      // Mobile: rewrite
      const n = parseCountFrom(el);
      if (!n) return; // leave as-is if unknown
      el.textContent = toBasedOnString(n);
      ensureTitleClass(el);
    });
  }

  // Helpers
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.prototype.slice.call((ctx || document).querySelectorAll(sel));

  // Throttled observer callback
  let scheduled = false;
  function scheduleProcess() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; process(); });
  }

  // Observe only relevant wrappers if present; otherwise watch body but still throttled
  function attachObserver() {
    const wrappers = $$(WRAP_SELECTOR);
    const mo = new MutationObserver((muts) => {
      for (let i = 0; i < muts.length; i++) {
        const m = muts[i];
        if (m.type === 'childList') {
          for (let j = 0; j < m.addedNodes.length; j++) {
            const n = m.addedNodes[j];
            if (n.nodeType === 1 && (n.matches?.(TARGET_SELECTOR) || n.querySelector?.(TARGET_SELECTOR))) {
              scheduleProcess(); return;
            }
          }
        } else if (m.type === 'attributes') {
          if (m.target.matches?.(TARGET_SELECTOR)) { scheduleProcess(); return; }
        }
      }
    });

    if (wrappers.length) {
      wrappers.forEach(w => mo.observe(w, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-shop-count'] }));
    } else {
      mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-shop-count'] });
    }

    window.addEventListener('pagehide', () => mo.disconnect(), { once: true });
  }

  // Run immediately and on resize/orientation changes
  process();
  attachObserver();
  window.addEventListener('resize', scheduleProcess, { passive: true });
  window.addEventListener('orientationchange', scheduleProcess, { passive: true });

})();


/* idk */
(function () {
  'use strict';

  // ---- Media gate: enable only below 1024px -------------------------------
  const MQ = window.matchMedia('(max-width: 1023.98px)');

  function addL(el, type, fn, opts){
    el.addEventListener(type, fn, opts);
    (el._infSwipeHandlers ||= []).push([type, fn, opts]);
  }
  function removeAllL(el){
    if (!el._infSwipeHandlers) return;
    for (const [type, fn, opts] of el._infSwipeHandlers) try{ el.removeEventListener(type, fn, opts); }catch(_){}
    el._infSwipeHandlers = [];
  }

  function enhanceInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe === '1') return;

    // make row scrollable even if theme sets o-hidden
    row.style.setProperty('overflow-x', 'auto', 'important');
    row.style.setProperty('overflow-y', 'hidden', 'important');
    row.style.setProperty('-webkit-overflow-scrolling', 'touch');
    row.style.touchAction = 'auto';
    row.classList.add('js-infinite-swipe');
    row.dataset.infiniteSwipe = '1';
    if (!row.hasAttribute('tabindex')) row.tabIndex = 0;

    const tracks = row.querySelectorAll('.brand-item-scroll');
    const pause  = () => tracks.forEach(t => t.style.animationPlayState = 'paused');
    const resume = () => tracks.forEach(t => t.style.animationPlayState = 'running');

    // nuke native image drag
    row.querySelectorAll('img').forEach(img => img.setAttribute('draggable','false'));
    addL(row, 'dragstart', (e) => {
      if (e.target && (e.target.tagName === 'IMG' || e.target.closest('img'))) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // thresholds
    const THRESH = 8; // px before deciding
    const BIAS   = 3; // horizontal must beat vertical by this

    // state
    let down=false, dragging=false, intent='undecided';
    let sx=0, sy=0, lastX=0, moved=0, resumeTimer=null;

    function lockH(e){
      intent='h'; dragging=true;
      row.classList.add('is-dragging');
      pause();
      if (row.setPointerCapture && e && e.pointerId != null) {
        try { row.setPointerCapture(e.pointerId); } catch(_) {}
      }
    }
    function lockV(){
      intent='v'; dragging=false;
      row.classList.remove('is-dragging');
      if (!resumeTimer) resumeTimer=setTimeout(resume,700);
    }
    function suppressClickOnce(ev){
      ev.preventDefault(); ev.stopPropagation();
      row.removeEventListener('click', suppressClickOnce, true);
    }

    // ---------- Pointer Events path ----------
    function onPointerDown(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=e.clientX; sy=e.clientY; lastX=e.clientX;

      // desktop: prevent native image/link drag immediately
      if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();

      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
    }
    function onPointerMove(e){
      if (!down) return;
      const dx = e.clientX - sx;
      const dy = e.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) { lockH(e); }
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else { return; }
      }
      if (!dragging) return;

      const delta = e.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = e.clientX;
      moved += Math.abs(delta);

      if (e.cancelable) e.preventDefault(); // kill text selection / drag while dragging
    }
    function onPointerUp(e){
      if (!down) return;
      down=false;
      if (dragging && moved > 5) row.addEventListener('click', suppressClickOnce, true);
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      if (row.releasePointerCapture && e?.pointerId != null) {
        try { row.releasePointerCapture(e.pointerId); } catch(_) {}
      }
      resumeTimer=setTimeout(resume,700);
    }

    // ---------- Touch fallback (iOS Safari quirks) ----------
    function getTouch(e){ return e.touches && e.touches[0] ? e.touches[0] : (e.changedTouches && e.changedTouches[0]); }

    function onTouchStart(e){
      const t = getTouch(e); if (!t) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=t.clientX; sy=t.clientY; lastX=t.clientX;
      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
      // do NOT preventDefault here; we still want vertical scroll if user goes vertical
    }
    function onTouchMove(e){
      if (!down) return;
      const t = getTouch(e); if (!t) return;
      const dx = t.clientX - sx;
      const dy = t.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) { lockH(); }
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else { return; }
      }
      if (!dragging) return;

      const delta = t.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = t.clientX;
      moved += Math.abs(delta);

      // IMPORTANT: once horizontal, stop page from trying to scroll
      if (e.cancelable) e.preventDefault();
    }
    function onTouchEnd(){
      if (!down) return;
      down=false;
      if (dragging && moved > 5) row.addEventListener('click', suppressClickOnce, true);
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      resumeTimer=setTimeout(resume,700);
    }

    // attach listeners (capture so we beat IMG/A defaults)
    if ('PointerEvent' in window) {
      addL(row, 'pointerdown', onPointerDown, { passive:false, capture:true });
      addL(row, 'pointermove',  onPointerMove,  { passive:false, capture:true });
      addL(row, 'pointerup',    onPointerUp,    { passive:true,  capture:true });
      addL(row, 'pointercancel',onPointerUp,    { passive:true,  capture:true });
      addL(row, 'mouseleave',   (e)=>{ if(down) onPointerUp(e); }, { passive:true, capture:true });
    } else {
      // Touch fallback (older iOS / Android WebView)
      addL(row, 'touchstart', onTouchStart, { passive:false, capture:true });
      addL(row, 'touchmove',  onTouchMove,  { passive:false, capture:true });
      addL(row, 'touchend',   onTouchEnd,   { passive:true,  capture:true });
      addL(row, 'touchcancel',onTouchEnd,   { passive:true,  capture:true });
      // Optional mouse fallback if needed:
      addL(row, 'mousedown', (e)=>{ onPointerDown(e); }, { passive:false, capture:true });
      addL(row, 'mousemove', (e)=>{ onPointerMove(e); }, { passive:false, capture:true });
      addL(row, 'mouseup',   (e)=>{ onPointerUp(e);   }, { passive:true,  capture:true });
      addL(row, 'mouseleave',(e)=>{ if(down) onPointerUp(e); }, { passive:true, capture:true });
    }
  }

  function teardownInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe !== '1') return;

    // remove listeners
    removeAllL(row);

    // restore styles/classes/attrs
    row.classList.remove('js-infinite-swipe','is-dragging');
    row.removeAttribute('data-infinite-swipe');
    row.style.removeProperty('overflow-x');
    row.style.removeProperty('overflow-y');
    row.style.removeProperty('-webkit-overflow-scrolling');
    row.style.removeProperty('touch-action');
    if (row.getAttribute('tabindex') === '0') row.removeAttribute('tabindex');

    // resume theme marquee
    row.querySelectorAll('.brand-item-scroll').forEach(t => {
      t.style.animationPlayState = '';
    });

    // allow images to be draggable again
    row.querySelectorAll('img[draggable="false"]').forEach(img => img.removeAttribute('draggable'));
  }

  function toggleAll(scope=document){
    const rows = scope.querySelectorAll('.brand-slider .halo-row.brand-layout--infinite');
    rows.forEach(row => {
      if (MQ.matches) enhanceInfiniteRow(row);
      else teardownInfiniteRow(row);
    });
  }

  // initial + live section events + MQ changes
  document.addEventListener('DOMContentLoaded', () => toggleAll());
  document.addEventListener('shopify:section:load',    (e) => toggleAll(e.target));
  document.addEventListener('shopify:section:select',  (e) => toggleAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => toggleAll(e.target));
  (MQ.addEventListener ? MQ.addEventListener('change', () => toggleAll())
                       : MQ.addListener(() => toggleAll()));
})();


/* idk */
(function () {
  'use strict';

  // ---- helpers -------------------------------------------------------------

  // clone child nodes of a track until we reach a target width multiplier
  function buildLoopBuffer(track, minMultiplier) {
    // strip any previous clones
    track.querySelectorAll('[data-clone="1"]').forEach(n => n.remove());

    // measure one "unit" width (original children only)
    const originals = Array.from(track.children).filter(n => n.dataset.clone !== '1');
    const unitWidth = originals.reduce((w, n) => w + n.getBoundingClientRect().width, 0);

    if (unitWidth === 0) return 0;

    // duplicate children until track width >= minMultiplier * unitWidth
    // (we do child-level cloning to avoid nesting tracks inside tracks)
    let copies = 0;
    while (track.scrollWidth < unitWidth * minMultiplier && copies < 20) {
      for (const node of originals) {
        const c = node.cloneNode(true);
        c.dataset.clone = '1';
        // keep a11y clean: avoid duplicate IDs & remove tabbability in clones
        if (c.id) c.id = '';
        c.querySelectorAll('[id]').forEach(el => el.id = '');
        c.querySelectorAll('a,button,[tabindex]').forEach(el => el.tabIndex = -1);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
      copies++;
    }
    return unitWidth;
  }

  // throttle scroll work with rAF
  function onScrollRAF(el, fn) {
    let ticking = false;
    el.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => { fn(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- main enhancer -------------------------------------------------------

  function enhanceInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe === '1') return;

    // force scrollability even if theme sets o-hidden
    row.style.setProperty('overflow-x', 'auto', 'important');
    row.style.setProperty('overflow-y', 'hidden', 'important');
    row.style.setProperty('-webkit-overflow-scrolling', 'touch');
    row.style.touchAction = 'pan-y';
    row.classList.add('js-infinite-swipe');
    row.dataset.infiniteSwipe = '1';
    row.tabIndex = 0;

    const tracks = Array.from(row.querySelectorAll('.brand-item-scroll'));
    if (!tracks.length) return;

    // 1) Build a minimal loop buffer for each track
    // We want at least ~3x the original content span to hide "teleports"
    const unitWidths = tracks.map(t => buildLoopBuffer(t, 3));
    const unit = Math.max(0, ...unitWidths);            // use the widest track as our loop span
    row.dataset.loopUnit = String(unit);

    // 2) Start centered inside the buffer so you can drag both ways
    if (unit > 0) row.scrollLeft = unit;

    // 3) Respect reduced motion: pause marquee if user prefers it
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setMotion = () => {
      tracks.forEach(t => t.style.animationPlayState = mql.matches ? 'paused' : 'running');
    };
    setMotion();
    mql.addEventListener?.('change', setMotion);

    // 4) Drag/swipe (desktop & mobile), no wheel hijack
    const THRESH = 8, BIAS = 3;
    let down=false, dragging=false, intent='undecided';
    let sx=0, sy=0, lastX=0, moved=0, resumeTimer=null;

    const pause = () => tracks.forEach(t => t.style.animationPlayState = 'paused');
    const resume = () => tracks.forEach(t => t.style.animationPlayState = mql.matches ? 'paused' : 'running');

    function lockH(e){
      intent='h'; dragging=true;
      row.classList.add('is-dragging');
      pause();
      if (row.setPointerCapture && e.pointerId != null) {
        try { row.setPointerCapture(e.pointerId); } catch(_) {}
      }
    }
    function lockV(){
      intent='v'; dragging=false;
      row.classList.remove('is-dragging');
      if (!resumeTimer) resumeTimer=setTimeout(resume,700);
    }

    function onDown(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=e.clientX; sy=e.clientY; lastX=e.clientX;
      // stop native image/link drag ASAP on desktop
      if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();
      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
    }

    function onMove(e){
      if (!down) return;
      const dx = e.clientX - sx;
      const dy = e.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) lockH(e);
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else return;
      }
      if (!dragging) return;

      const delta = e.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = e.clientX;
      moved += Math.abs(delta);
      if (e.cancelable) e.preventDefault();   // kill image/text selection while dragging
    }

    function onUp(e){
      if (!down) return;
      down=false;

      if (dragging && moved > 5) {
        row.addEventListener('click', suppressOnce, true); // block click-through
      }
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      resumeTimer=setTimeout(resume,700);

      if (row.releasePointerCapture && e?.pointerId != null) {
        try { row.releasePointerCapture(e.pointerId); } catch(_) {}
      }
    }

    function suppressOnce(ev){
      ev.preventDefault(); ev.stopPropagation();
      row.removeEventListener('click', suppressOnce, true);
    }

    row.addEventListener('pointerdown', onDown, { passive:false, capture:true });
    row.addEventListener('pointermove',  onMove, { passive:false, capture:true });
    row.addEventListener('pointerup',    onUp,   { passive:true,  capture:true });
    row.addEventListener('pointercancel',onUp,   { passive:true,  capture:true });
    row.addEventListener('mouseleave',   (e)=>{ if(down) onUp(e); }, { passive:true, capture:true });

    // 5) Seamless wrap: keep scrollLeft within the middle band so it never ends
    function wrapIfNeeded(){
      const span = +row.dataset.loopUnit || 0;
      if (!span) return;
      const x = row.scrollLeft;

      // stay inside [0.25*span, 1.75*span] by shifting by ±span when needed
      // this avoids visible jumps because we have ~3x buffer width.
      if (x < span * 0.25) {
        row.scrollLeft = x + span;
      } else if (x > span * 1.75) {
        row.scrollLeft = x - span;
      }
    }
    onScrollRAF(row, wrapIfNeeded);

    // 6) Rebuild on resize (fonts/images can change widths)
    const ro = new ResizeObserver(() => {
      const unitWidths2 = tracks.map(t => buildLoopBuffer(t, 3));
      const newUnit = Math.max(0, ...unitWidths2);
      row.dataset.loopUnit = String(newUnit);
      if (newUnit > 0) row.scrollLeft = newUnit; // recenter
    });
    ro.observe(row);
  }

  function init(scope=document){
    scope.querySelectorAll('.brand-slider .halo-row.brand-layout--infinite').forEach(enhanceInfiniteRow);
  }

  // expose for Shopify section reloads
  function enhanceInfiniteRow(row){ enhanceInfiniteRow = enhanceInfiniteRow; } // no-op placeholder
  // actual init hooks
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load',    e => init(e.target));
  document.addEventListener('shopify:section:select',  e => init(e.target));
  document.addEventListener('shopify:section:reorder', e => init(e.target));
})();


/* dimmy dim dim on hovity hover hover */
(function () {
  'use strict';

  // ------------ CONFIG ------------
  const CFG = {
    desktopMQ: '(min-width: 1024px) and (hover: hover) and (pointer: fine)',
    sliderRoot: '.brand-slider',            // preferred wrapper
    trackSel:   '.brand-item-scroll',       // track containing items
    rootAttr:   'data-brand-slider-root',   // we tag real sliders with this
    htmlAttr:   'data-brand-dim',           // set "1" when dimming is active
    itemActive: 'data-active-item',         // set "1" on the one undimmed item
    styleId:    'brand-dim-v9',
    dimOpacity: 0.5,
    transMs:    120
  };

  // Remove old style blocks (defensive)
  ['brand-slider-dim-active-desktop','brand-slider-dim-desktop-v7','brand-slider-dim-v8',
   'brand-slider-dimming-style-v6','brand-slider-dimming-style-v5','brand-slider-dimming-style-scoped',
   'brand-hover-dimming-style-v4','brand-hover-dimming-style-v3','brand-hover-dimming-style-v2',
   'brand-hover-dimming-style'
  ].forEach(id => { const n = document.getElementById(id); if (n) n.remove(); });

  // CSS (scoped + !important so theme CSS can’t override)
  function injectStyle() {
    if (document.getElementById(CFG.styleId)) return;
    const s = document.createElement('style');
    s.id = CFG.styleId;
    s.textContent = `
      @media ${CFG.desktopMQ} {
        [${CFG.rootAttr}="1"] ${CFG.trackSel} > * {
          transition: opacity ${CFG.transMs}ms ease;
          will-change: opacity;
        }
        html[${CFG.htmlAttr}="1"] [${CFG.rootAttr}="1"] ${CFG.trackSel} > * {
          opacity: ${CFG.dimOpacity} !important;
        }
        html[${CFG.htmlAttr}="1"] [${CFG.rootAttr}="1"] ${CFG.trackSel} > *[${CFG.itemActive}="1"] {
          opacity: 1 !important;
        }
        @media (prefers-reduced-motion: reduce) {
          [${CFG.rootAttr}="1"] ${CFG.trackSel} > * { transition: none; }
        }
      }
    `;
    document.head.appendChild(s);
  }

  // Desktop gate
  const mq = window.matchMedia(CFG.desktopMQ);
  const isDesktop = () => mq.matches;

  // Tag only real slider roots (must contain a track)
  function tagRoots(scope = document) {
    const roots = new Set();
    scope.querySelectorAll(CFG.trackSel).forEach(track => {
      const root = track.closest(CFG.sliderRoot) || track.closest('.shopify-section') || track.parentElement;
      if (root) roots.add(root);
    });
    roots.forEach(r => r.setAttribute(CFG.rootAttr, '1'));
    return Array.from(roots);
  }

  // Returns the direct item (child of track) under a DOM target/point
  function directItemFrom(el) {
    if (!el) return null;
    const track = el.closest(`${CFG.sliderRoot} ${CFG.trackSel}, [${CFG.rootAttr}="1"] ${CFG.trackSel}`);
    if (!track) return null;
    // ensure we return the *direct* child of the track
    for (const child of track.children) {
      if (child.contains(el)) return child;
    }
    return null;
  }

  // State
  let unsubs = [];
  let activeItem = null;
  let rafPending = false;
  let lastPoint = { x: 0, y: 0 };

  const setHtmlDim = (on) => {
    const html = document.documentElement;
    if (on) html.setAttribute(CFG.htmlAttr, '1');
    else html.removeAttribute(CFG.htmlAttr);
  };

  function setActive(next) {
    if (next === activeItem) return;
    if (activeItem) activeItem.removeAttribute(CFG.itemActive);
    activeItem = next || null;
    if (activeItem) {
      activeItem.setAttribute(CFG.itemActive, '1');
      setHtmlDim(true);
    } else {
      setHtmlDim(false);
    }
  }

  // rAF-coalesced hover resolver using elementFromPoint
  function scheduleResolve() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      if (!isDesktop()) { setActive(null); return; }
      const el = document.elementFromPoint(lastPoint.x, lastPoint.y);
      const item = directItemFrom(el);
      setActive(item);
    });
  }

  function bind(scope = document) {
    injectStyle();
    tagRoots(scope);

    // Pointer tracking (desktop only)
    const onPointerMove = (e) => {
      if (!isDesktop() || e.pointerType !== 'mouse') return;
      lastPoint.x = e.clientX;
      lastPoint.y = e.clientY;
      scheduleResolve();
    };

    const onPointerLeaveWindow = (e) => {
      // If pointer left viewport, clear
      if (!e.relatedTarget && !e.toElement) setActive(null);
    };

    // Keyboard focus support
    const onFocusIn = (e) => {
      if (!isDesktop()) return;
      const item = directItemFrom(e.target);
      if (item) setActive(item);
    };
    const onFocusOut = () => {
      if (!isDesktop()) return;
      setTimeout(() => {
        const item = directItemFrom(document.activeElement);
        setActive(item || null);
      }, 0);
    };

    // Page visibility/blur safety
    const onBlur = () => setActive(null);
    const onHidden = () => { if (document.hidden) setActive(null); };

    document.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('mouseout', onPointerLeaveWindow, { passive: true });
    document.addEventListener('focusin',  onFocusIn,  { passive: true });
    document.addEventListener('focusout', onFocusOut, { passive: true });
    window.addEventListener('blur', onBlur, { passive: true });
    document.addEventListener('visibilitychange', onHidden, { passive: true });

    unsubs.push(() => {
      document.removeEventListener('pointermove', onPointerMove, { passive: true });
      window.removeEventListener('mouseout', onPointerLeaveWindow, { passive: true });
      document.removeEventListener('focusin',  onFocusIn,  { passive: true });
      document.removeEventListener('focusout', onFocusOut, { passive: true });
      window.removeEventListener('blur', onBlur, { passive: true });
      document.removeEventListener('visibilitychange', onHidden, { passive: true });
    });

    // Initial: nothing dimmed
    setActive(null);
  }

  function teardown() {
    unsubs.forEach(fn => { try { fn(); } catch(_){} });
    unsubs = [];
    setActive(null);
  }

  function enableIfDesktop(scope = document) {
    teardown();
    if (isDesktop()) bind(scope);
  }

  // Bootstrap after full load; rebind on Shopify section events; respond to MQ changes
  window.addEventListener('load', () => enableIfDesktop());
  document.addEventListener('shopify:section:load',    e => enableIfDesktop(e.target));
  document.addEventListener('shopify:section:select',  e => enableIfDesktop(e.target));
  document.addEventListener('shopify:section:reorder', e => enableIfDesktop(e.target));
  (mq.addEventListener ? mq.addEventListener('change', () => enableIfDesktop())
                       : mq.addListener(() => enableIfDesktop()));
})();